import './SkeletonList.css';
import { Skeleton, SkeletonCard, SkeletonMessage } from './Skeleton';
import { SkeletonAvatar } from './SkeletonAvatar';

export type SkeletonListItem = 'row' | 'card' | 'message';

export type SkeletonListProps = {
    count?: number;
    item?: SkeletonListItem;
    gap?: 'sm' | 'md' | 'lg';
    className?: string;
};

function RowItem() {
    return (
        <div className="skeleton-list__row">
            <SkeletonAvatar size="md" />
            <div className="skeleton-list__row-text">
                <Skeleton width="45%" height="13px" />
                <Skeleton width="72%" height="11px" />
            </div>
        </div>
    );
}

export function SkeletonList({
    count = 4,
    item = 'row',
    gap = 'md',
    className = '',
}: SkeletonListProps) {
    return (
        <div
            className={`skeleton-list skeleton-list--gap-${gap} ${className}`}
            role="status"
            aria-busy="true"
            aria-label="Loading list"
        >
            {Array.from({ length: count }, (_, i) => {
                if (item === 'card') return <SkeletonCard key={i} />;
                if (item === 'message') {
                    const align = i % 2 === 0 ? 'left' : 'right';
                    return <SkeletonMessage key={i} align={align} />;
                }
                return <RowItem key={i} />;
            })}
        </div>
    );
}
